import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-edhafi',
  templateUrl: './form-edhafi.component.html',
})
export class FormEdhafiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
